import type { IEnvConfig } from '../types';
import { sarosThemeFormat } from './helpers';

export const sarosgameConfig: IEnvConfig = {
  name: 'sarosgame',
  survey: {
    callbackURL: 'https://uxlab.sarosgame.qq.com/api/v1/callback/survey',
  },
  desktop: {
    namespace: 'uxlab.sarosgame', // SarosGame 环境的域名
    versionLabel: 'SarosGame',
    hasTestEnv: false,
  },
  cos: {
    bucket: 'uxlab-saros-1253502009',
    region: 'ap-guangzhou',
  },
  group: {
    groupBy: 'round',
    groupIdField: 'round_id',
    themeFormat: sarosThemeFormat,
  },
  ui: {
    bodyClass: '',
    cardPTeamClass: false,
    subtitleDuration: 3,
    dateFormat: 'yyyy-MM-dd HH:mm:ss',
    defaultPlayerMode: 0,
    loginIconType: 'uxlab',
    sloganStyle: 'uxlab',
  },
  features: {
    enableBeacon: false,
    enableAegis: false,
    showTopText: true,
    showUsageReason: false,
    showRoundSelect: true,
    showOperationGuide: false,
    showRemoteControl: false,
    canEditProductName: true,
    canEditProductOwner: true,
    canEditRound: true,
    showSessionCount: true,
    showRegisterHint: false,
    showLoginFooter: false,
    showThemeInClassify: true,
    showGroupVideoLayout: true,
    showDualShareLinks: true,
    showDeviceEquipment: true,
    showUsageNotice: false,
    showMobileTipsBar: true,
    isAggregatedByUnionId: false,
    showProjectAssociation: false,
    usePusherScheme1080p: true,
    showThemeRequiredForMultipleSessions: false,
    showMultiPusher: false,
    showPlayerInfoDialog: true, // 萨罗斯版保留「设备和玩家信息」弹窗
    showMaterialTest: false, // L6 阉割：无素材测试入口
    showCloudCE: false, // L6 阉割：无云端CE入口
    showAsrLangSwitch: false, // L6 阉割：只保留基础中英识别
    showCaptionTranslation: false, // L6 阉割：取消翻译栏
    showBorrowableDevice: false,
    showSmartSummary: false,
  },
  text: {
    appTitle: '萨罗斯用研室系统',
    adminContact: 'lilymmzhang(张梦婷)',
    adminContactLink: 'wxwork://message.com/?username=',
    adminEmail: '',
    accountLabel: '账号',
    copySuccessMessage: '已将链接复制至剪贴板',
    inviteSuccessMessage: '座谈会信息已复制到剪切板',
    shareSuccessMessage: '分享信息已复制到剪切板',
    registerHint: '开始注册腾讯互娱体验室系统!',
    waitApprovalHint: '请等待管理员审核',
    checkEmailHint: '请注意查收邮件~',
    nonTencentUserHint: '非腾讯用户需使用邮箱账号注册，并通过管理员审核方可观看。',
    contactAdminHint: '如您有非腾讯用户需要观看，请提前联系',
    labContactTip: '如当前设备数量不满足需求，可联系lilymmzhang(张梦婷)',
    sloganDesc: '',
  },
};
